import Hero from "./components/Hero";
import TopRank from "./components/TopRank";
import HeatRank from "./components/HeatRank";
import CategoryGrid from "./components/CategoryGrid";
import EditorPick from "./components/EditorPick";
import Intro from "./components/Intro";
import Faq from "./components/Faq";
import Newsletter from "./components/Newsletter";
import useSeo from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";

export default function Home() {
  const top = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "漫天堂",
      description: "聚合漫画人气榜与热度排行，实时更新编辑推荐与高分漫画的推荐平台。",
      url: "https://bestmanga.github.io/",
      logo: "https://bestmanga.github.io/favicon.svg",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "漫天堂",
      url: "https://bestmanga.github.io/",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://bestmanga.github.io/category/{search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "漫天堂 · 漫画人气榜与热度排行",
      url: "https://bestmanga.github.io/",
      inLanguage: "zh-CN",
      description:
        "漫天堂聚合人气榜与热度排行，实时更新编辑推荐与高分漫画，必看清单帮你快速锁定最值得追的作品。",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "人气榜和热度排行有什么区别？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "人气榜综合阅读量、追更数、讨论热度和编辑口碑等多维度数据，更偏重综合口碑；热度排行则更关注近期的实时飙升趋势，帮你发现正在快速蹿红的作品。",
          },
        },
        {
          "@type": "Question",
          name: "什么是必看清单？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "必看清单由编辑部从口碑、评分、完本质量与人气中精选，是当前最值得一追的作品合集。",
          },
        },
        {
          "@type": "Question",
          name: "高分漫画的评分是怎么来的？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "评分综合了读者真实评价、编辑评分与作品质量，满分 10 分，会随读者反馈动态调整。",
          },
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "漫天堂今日人气 TOP 5",
      itemListElement: top.map((a, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: a.title,
        url: `https://bestmanga.github.io/article/${a.slug}`,
      })),
    },
  ];

  useSeo({
    title: "漫天堂 | 漫画人气榜与热度排行，高分漫画推荐榜单必看清单",
    description:
      "漫天堂聚合人气榜与热度排行，实时更新编辑推荐与高分漫画。必看清单帮你快速锁定当前最值得追的作品，从口碑神作到热门新番一页掌握，告别选择困难。",
    keywords:
      "漫天堂,漫天堂人气榜,漫天堂热度排行,漫天堂推荐榜单,漫天堂必看清单,漫天堂高分漫画,漫天堂编辑推荐",
    canonicalPath: "/",
    ogType: "website",
    jsonLd,
  });

  return (
    <>
      <Hero />
      <TopRank />
      <CategoryGrid />
      <HeatRank />
      <EditorPick />
      <Intro />
      <Faq />
      <Newsletter />
    </>
  );
}